import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  fonts: {
    heading: 'tajawal',
    body: 'tajawal',
  },
});

export default theme;